<app-upload-multiple-files-modal [title]="title" [subtitle]="subtitle" [isUploadable]="isUploadable"
  [filesExisted]="filesExisted" (existedFileDeleted)="deleteExistedFile($event)" (uploadFiles)="addedFiles($event)"
  [isOkayToSubmit]="!!testDate && (!isHaveSelect || (isHaveSelect && !!selectedOption))" [isUpdate]="isUpdate">
  <div class="form-group w-100" *ngIf="isHaveContent">
    <div class="row justify-content-between">
      <div [ngClass]="{'col-md-4 mb-2': isHaveSelect, 'col-md-12 mb-2': !isHaveSelect}">
        <label class="form-control-label black-text" for="test-date">
          Test Date
        </label>
        <input class="form-control black-text" id="test-date" type="date" name="testDate" required
          [value]="testDate | date: 'yyyy-MM-dd'" [(ngModel)]="testDate" />
      </div>
      <div *ngIf="isHaveSelect" class="col-md-4 mb-2">
        <label class="form-control-label black-text" for="file">
          {{selectTitle}}
        </label>
        <select class="form-control" id="select-option" (change)="getTestsByTypeId(selectedOption)"
          [(ngModel)]="selectedOption" required>
          <option [ngValue]="null" [disabled]="true">{{selectFirstOptionValue}}</option>
          <option *ngFor="let selectOption of selectOptions" [ngValue]="selectOption.key">
            {{ selectOption.value }}
          </option>
        </select>
      </div>
      <div class="col-md-4 mb-2" *ngIf="recentMedicalTests">
        <label class="form-control-label black-text" for="tests">
          Tests
        </label>

        <ng-select id="tests" name="tests" bindLabel="name" bindValue="id" placeholder="Search for tests"
          [(ngModel)]="testsIds" typeToSearchText="Search Tests" notFoundText="No Tests Found"
          dropdownPosition="bottom" [multiple]="true" [searchable]="true" [closeOnSelect]="false"
          [clearSearchOnAdd]="true" [virtualScroll]="true" [items]="tests">
        </ng-select>

      </div>
      <div class="col-md-12 mb-2" *ngIf="recentMedicalTests">
        <label class="form-control-label black-text" for="doctorName">
          Doctor Name
        </label>
        <input class="form-control black-text" id="doctorName" type="text" name="doctorName" placeholder="Doctor Name"
          [(ngModel)]="doctorName" />
      </div>
    </div>
  </div>
</app-upload-multiple-files-modal>